import { BodyContent } from 'components/BodyContent/BodyContent';
import React, { useContext } from 'react';
import { SitemapPageResponse } from 'src/service/engageFrontendGateway';
import { useTranslation } from 'react-i18next';
import { PageContext } from 'src/context/PageContext';
import { buildPublicPathFromSlug } from 'utils/publicUrlRule';
import styles from './Sitemap.module.scss';

export function Sitemap({
  pages,
  urlParams,
}: {
  pages: SitemapPageResponse['items'];
  urlParams: { organization: string; locale: string };
}) {
  const { t } = useTranslation();
  const { linkHostname } = useContext(PageContext);
  const pathTo = (...rest: string[]) =>
    buildPublicPathFromSlug([urlParams.organization, urlParams.locale, ...rest], linkHostname);
  const hubs = pages.filter((page) => page.pageType === 'hub');
  const projects = pages.filter((page) => page.pageType === 'project');
  const updates = pages.filter((page) => page.pageType === 'update');
  return (
    <BodyContent>
      <div className={styles.container}>
        <h1>
          <a className={styles.link} href={pathTo()}>
            {t('home')}
          </a>
        </h1>
        {hubs.length > 0 && (
          <div>
            <h2>{t('hubs')}</h2>
            <ul>
              {hubs.map((page) => (
                <li key={page.id}>
                  <a className={styles.link} href={pathTo('pages', page.slug || page.id)}>
                    {page.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        {projects.length > 0 && (
          <div>
            <h2>{t('projects')}</h2>
            <ul>
              {projects.map((page) => (
                <li key={page.id}>
                  <a className={styles.link} href={pathTo('projects', page.slug || page.id)}>
                    {page.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        {updates.length > 0 && (
          <div>
            <h2>{t('updates')}</h2>
            <ul>
              {updates.map((page) => (
                <li key={page.id}>
                  <a className={styles.link} href={pathTo('pages', page.slug || page.id)}>
                    {page.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </BodyContent>
  );
}
